/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Solo para el post de la landing [no hay diseño de pantalla]
 * @export
 * @interface CompanyNewCompany
 */
export interface CompanyNewCompany {
    /**
     * 
     * @type {string}
     * @memberof CompanyNewCompany
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyNewCompany
     */
    nif?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyNewCompany
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyNewCompany
     */
    contactEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyNewCompany
     */
    contactPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyNewCompany
     */
    contactName?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyNewCompany
     */
    contactSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyNewCompany
     */
    contactPhone?: string;
}

export function CompanyNewCompanyFromJSON(json: any): CompanyNewCompany {
    return CompanyNewCompanyFromJSONTyped(json, false);
}

export function CompanyNewCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyNewCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'nif': !exists(json, 'nif') ? undefined : json['nif'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'contactEmail': !exists(json, 'contact_email') ? undefined : json['contact_email'],
        'contactPassword': !exists(json, 'contact_password') ? undefined : json['contact_password'],
        'contactName': !exists(json, 'contact_name') ? undefined : json['contact_name'],
        'contactSurname': !exists(json, 'contact_surname') ? undefined : json['contact_surname'],
        'contactPhone': !exists(json, 'contact_phone') ? undefined : json['contact_phone'],
    };
}

export function CompanyNewCompanyToJSON(value?: CompanyNewCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'nif': value.nif,
        'text': value.text,
        'contact_email': value.contactEmail,
        'contact_password': value.contactPassword,
        'contact_name': value.contactName,
        'contact_surname': value.contactSurname,
        'contact_phone': value.contactPhone,
    };
}


